module.exports = __webpack_public_path__ + "img/homepage-banners-mazda-compliant-chevy.15c978d1.jpg";